import {axiosInstance} from "../utils/axios";

export const getSubjectList = () => {
    return axiosInstance.get('subjects/');
};

export const getAllVirtualClassesForStudentRTQ = () => {
    return axiosInstance.get(`students/virtual-classes`);
}